import {
	archiveFriendById,
	blockFriendById,
	declineFriendMatch,
	listFriends,
	type MatchResultBody,
	openFriendMatch,
	unarchiveFriendById,
	unblockFriendById,
} from "@/shared/api/generated-social"
import type { Friend } from "../model/types"

// friends/block/unblock живут в social-service. На backend та же модель UserOut
// не знает source='social-match' и падает 500.

export async function getFriends(): Promise<Friend[]> {
	const { friends } = await listFriends()
	return friends
}

export async function blockFriend(userId: number, friendId: number) {
	return blockFriendById({
		path: { friend_id: friendId },
		body: { user_id: userId },
	})
}

export async function unblockFriend(userId: number, friendId: number) {
	return unblockFriendById({
		path: { friend_id: friendId },
		body: { user_id: userId },
	})
}

// Проверка на тапе по карточке во вкладке «Новые». Список ничего не знает про
// судьбу мэтча — карточка там лежит и после отказа второй стороны, как того
// требует продукт. Узнаём первым же действием. Кто закрыл мэтч: declined =
// человек на той стороне, expired = система. На этом экране оба исхода ведут
// в один попап «мэтч уже неактуален» — различать юзеру нечего.
export async function openMatch(
	userId: number,
	friendId: number,
): Promise<MatchResultBody["result"]> {
	const { result } = await openFriendMatch({
		path: { friend_id: friendId },
		body: { user_id: userId },
	})
	return result
}

// The decline endpoint for a match is in the same group as
// `friends/{id}/block|unblock`. The command applies to the pair of users. The
// backend finds the current open match, thus the client does not send a match ID.

// Единственный исход — "ok": любое состояние мэтча схлопывается в «отклонение
// применено», ветвиться не на чем.
export async function declineMatch(userId: number, friendId: number) {
	await declineFriendMatch({
		path: { friend_id: friendId },
		body: { user_id: userId },
	})
}

// Архив контактов (вкладка «Архив» на /home) — то же семейство
// friends/{friend_id}/*, что и block/unblock/decline.

export async function archiveFriend(userId: number, friendId: number) {
	await archiveFriendById({
		path: { friend_id: friendId },
		body: { user_id: userId },
	})
}

export async function unarchiveFriend(userId: number, friendId: number) {
	await unarchiveFriendById({
		path: { friend_id: friendId },
		body: { user_id: userId },
	})
}
